export interface CoverItem {
  id: string;
  code: string;
  category: string;
  description?: string;
  value: number;
  serialNumber: CoverTypes;
}

export interface DynamicCoverQuestion {
  cover: ClassType;
  options: DynamicCoverOption[];
}

export interface DynamicCoverOption {
  questionId: string;
  title: string;
  clauseCode: string;
  length: number;
  indent: number;
  order: number;
  type: string;
}

export interface PlumbingLicence {
  name: string;
  number: string;
}

/** @todo rename this to Cover */
export enum ClassType {
  LIABILITY = 'LIABILITY',
  PROPERTY = 'PROPERTY',
  BUSINESS_INTERRUPTION = 'BUSINESS_INTERRUPTION',
  GENERAL_PROPERTY = 'GENERAL_PROPERTY',
  THEFT = 'THEFT',
  MONEY = 'MONEY',
  GLASS = 'GLASS',
  MACHINERY = 'MACHINERY',
  TAX_AUDIT = 'TAX_AUDIT',
}

/** @todo rename this to UICover */
export enum Cover {
  Liability = 'Business Liability',
  BuildingAndContents = 'Business Buildings and Contents',
  BusinessInterruption = 'Business Interruption',
  PortableItems = 'Portable Items',
  Theft = 'Theft',
  Money = 'Money',
  Glass = 'Glass',
  Breakdown = 'Machinery Breakdown',
  TaxAudit = 'Tax Audit',
}

export type CoverType =
  | 'LIABILITY'
  | 'PROPERTY'
  | 'BUSINESS_INTERRUPTION'
  | 'GENERAL_PROPERTY'
  | 'THEFT'
  | 'MONEY'
  | 'GLASS'
  | 'BREAKDOWN'
  | 'TAX_AUDIT';

export enum CoverTypes {
  GENERAL = '{GENERAL}',
  SPECIFIED = '{SPECIFIED}',
}

export enum DynamicCoverQuestionID {
  TOBACCO_SI = 'TOBACCO_SI',
}

/* Business Building and Contents */

export enum Construction {
  BrickWallsConcreteFloors = '1',
  BrickWallsWoodFloors = '2',
  Other = '3',
  EPSOver20 = '4',
}

export enum AnzsicCPIType {
  ElectricianQLD = 'ELECTRICIAN_QLD',
  PlumberVIC = 'PLUMBER_VIC',
}
